import React from "react";
import ReactDOM from "react-dom/client";
import Router from "./router";
import "./index.scss";
import "preline/preline";

// declare global {
//   interface Window {
//     HSStaticMethods: IStaticMethods;
//   }
// }

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <Router />
  </React.StrictMode>
);
